import { Alert } from "@mui/lab";
import { AppBar, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, FormLabel, Grid, ImageList, ImageListItem, ImageListItemBar, Link, Radio, RadioGroup, Tab, TextField } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { createStyles, StyledComponentProps, withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Core";
import { FilterBarStyleClasses, GlobalClassKeys, TabLargeStyle } from 'assets/jss/common-styles';
import classNames from "classnames";
import { AppBarTabs } from "components/AppTabs";
import ButtonCancel from 'components/Buttons/ButtonCancel';
import ButtonConfirmAndClose from 'components/Buttons/ButtonConfirmAndClose';
import { SpinnerIndicator } from 'components/CallServer';
import { PasteContainer } from 'components/GlueJar';
import IconBack from 'components/Icons/IconBack';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiPagination from 'components/MuiExtras/MuiPagination';
import { withSnackbar, WithSnackbar } from 'components/SnackbarProvider/Snackbar';
import { FileUploadResult } from 'lib/AsyncUploader';
import { Formaters } from 'lib/Formarters';
import { convertBlobToBase64, convertUrlToBase64, Resizer, revokeObjectUrlIfBlob } from "lib/ImageResizer";
import { AzureSearchImageItem, AzureSearchImageResult } from 'models/ApiModels';
import * as React from 'react';
import Dropzone from 'react-dropzone';
import { useTranslation, WithTranslation, withTranslation } from 'react-i18next';
import ReactCrop, { Crop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const MaxHeightImageContainer = 256;
const MaxWidthImageContainer = 256;

export const ImageSelectionStyles = (theme: Theme) => createStyles({
    ...FilterBarStyleClasses(theme),

    dropZone: {
        border: "dashed 1px #808080",
    },

    imageContainer: {
        width: "100%",
        padding: "4px",
        backgroundColor: "#808080",
    },

    imageBorder: {
        textAlign: "center",
        border: "solid 1px #000",
    },

    imageCrop: {
        height: MaxHeightImageContainer
    },

    gridRoot: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },

    gridList: {
        width: "100%",
        height: 300,
    },

    gridListTile: {
        cursor: "pointer",
        height: "100%",
        display: "block",
        overflow: "hidden",
        position: "relative",
        backgroundColor: '#808080',
        textAlign: "center"
    },

    gridListImg: {
        cursor: "pointer",
        width: "auto",
        height: "100%",
        left: "auto",
        top: "50%",
        position: "relative",
        transform: "translateY(-50%)"
    },

    gridIcon: {
        color: 'rgba(255, 255, 255, 0.54)',
    },

    imageBoxArea: {
        width: MaxWidthImageContainer,
        height: MaxHeightImageContainer,
        margin: "0 auto",
        display: "block",
        backgroundColor: "#000",
    },

    previewImageW: {
        maxWidth: "100%"
    },
    previewImageH: {
        maxHeight: "100%"
    },
    fullHeight: {
        height: "100%"
    },
    fullWidth: {
        width: "100%"
    }
});

type ImageSelectionStyleTypes = StyledComponentProps<"imageContainer" | "imageBorder" | "imageCrop" | "dropZone" | "gridRoot" | "ImageList" | "ImageListItem" | "ImageListImg" | "gridIcon" | "imageBoxArea" | "previewImageW" | "previewImageH" | "fullHeight" | "fullWidth">;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface ImageSelectionResult {
    source: FileUploadResult;
    editedImage: FileUploadResult;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IRenderMenu {
    category: string;
    onChange: (event: React.ChangeEvent<{}>, value: any) => void;
}

const RenderMenuBar: React.FC<Props & IRenderMenu> = (props) => {
    const { t } = useTranslation();
    return (
        <div className={props.classes.filterTabContainer} style={{ marginBottom: 8 }}>
            <AppBar position="static" color="default" classes={{ root: props.classes.appTabFilterRoot }}>
                <AppBarTabs
                    value={props.category}
                    onChange={props.onChange}
                    centered
                >
                    <Tab value="library" style={TabLargeStyle} label={t("Components.ImageSelectionDialog.TabLibraryText")} />
                    <Tab value="local" style={TabLargeStyle} label={t("Components.ImageSelectionDialog.TabUploadImageText")} />
                </AppBarTabs>
            </AppBar>
        </div>
    );
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IEditImageState {
    image: string;
    crop: Crop;
    previewImage: ConvertUrlToBase64Result;
    option: string;
    rotate: number;
}

interface IEditImageProps extends ImageDimensions {
    src: string;
    onChange: (data: ConvertUrlToBase64Result) => void;
    onError: (message: string) => void;
}

type EditImageProps = IEditImageProps & ImageSelectionStyleTypes & WithTranslation;

class EditImage extends React.Component<EditImageProps, IEditImageState> {

    private imageRef: HTMLImageElement;
    private originalSize: any;

    constructor(props: EditImageProps) {
        super(props);

        this.state = {
            option: "crop",
            previewImage: null,
            image: null,
            crop: null,
            rotate: 0,
        };
    }

    private handleOptionChange = (event: React.ChangeEvent<{}>, value: string) => {
        this.setState({ option: value });
    };

    private changeResult(dataUrl: ConvertUrlToBase64Result) {
        if (this.state.previewImage && this.state.previewImage.dataUrl) revokeObjectUrlIfBlob(this.state.previewImage.dataUrl);
        this.setState({ previewImage: dataUrl });
        this.props.onChange(dataUrl);
    }

    private resizeImage(imageElement: HTMLImageElement) {
        var r = new Resizer();
        r.createResizedImage(
            imageElement,
            this.props.width,
            this.props.height,
            "png",
            100,
            this.state.rotate,
            (data) => {
                this.changeResult(data);
            },
        );
    }

    //#region Redimensionar Imagem

    private onLoadImageToRedim(imageElement: HTMLImageElement) {

        if (imageElement.width > imageElement.height) {
            imageElement.style.maxWidth = "100%";
        }
        else {
            imageElement.style.maxHeight = "100%";
        }

        this.resizeImage(imageElement);
    }

    private handleRotateChange = (event: React.ChangeEvent<{}>, value: string) => {
        this.setState({ rotate: parseInt(value) }, () => this.resizeImage(document.getElementById("imgResize") as HTMLImageElement));
    };

    //#endregion

    //#region Cortar Imagem

    private onCropImageLoaded = (image: HTMLImageElement) => {
        this.imageRef = image;
        this.makeClientCrop(this.state.crop);
    };

    private onCropComplete = (crop: Crop) => {
        this.makeClientCrop(crop);
    };

    private onCropChange = (crop: Crop) => {
        this.setState({ crop });
    };

    private makeClientCrop(crop: any) {
        if (this.imageRef && crop.width && crop.height) {
            var img = new Image();
            img.src = this.getCroppedImg(this.imageRef, crop);
            img.onload = () => {
                this.resizeImage(img);
            };
            img.onerror = () => {
                this.props.onError(this.props.t("Components.ImageSelectionDialog.EditCropError"));
            };
        }
    }

    private getCroppedImg(image: HTMLImageElement, crop: Crop): string {
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;

        const canvas = document.createElement("canvas");
        canvas.width = crop.width * scaleX;
        canvas.height = crop.height * scaleY;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            canvas.width,
            canvas.height,
            0,
            0,
            canvas.width,
            canvas.height
        );

        return canvas.toDataURL("image/png", 100);
    }

    //#endregion

    ///
    public componentDidMount() {
        convertUrlToBase64(this.props.src)
            .then((convert) => {
                // Área de CROP
                const p = (convert.width > convert.height)
                    ? convert.width / MaxWidthImageContainer
                    : convert.height / MaxHeightImageContainer;

                const maxW = Math.ceil(convert.width / p),
                    maxH = Math.ceil(convert.height / p),
                    min = Math.min(maxW, maxH);

                const isWide = this.props.width > this.props.height;

                const aspect = isWide
                    ? this.props.width / this.props.height
                    : this.props.height / this.props.width;

                this.originalSize = { width: convert.width, height: convert.height };

                this.setState({
                    image: convert.dataUrl,
                    crop: {
                        aspect: aspect,
                        unit: 'px',
                        width: aspect == 1 ? min : isWide ? Math.ceil(maxW) : null,
                        height: aspect == 1 ? min : isWide ? null : Math.ceil(maxH),
                        x: 0,
                        y: 0
                    }
                });
            })
            .catch(() => {
                this.props.onError(this.props.t("Components.ImageSelectionDialog.EditImageLoadError"));
            });
        ;
    }

    ///
    public componentWillUnmount() {
        if (this.state.image) revokeObjectUrlIfBlob(this.state.image);
        if (this.state.previewImage) revokeObjectUrlIfBlob(this.state.previewImage.dataUrl);
    }

    ///
    public render() {
        const { crop, previewImage, image, option, rotate } = this.state;
        const { classes } = this.props;

        if (image == null)
            return <SpinnerIndicator />;

        const canBeCropped = true; //(image.width > width || image.height > height);

        return (
            <>
                <Grid container justifyContent="space-between">
                    {
                        canBeCropped &&
                        <Grid item>
                            <FormGroup>
                                <RadioGroup
                                    row
                                    name="method"
                                    value={option}
                                    onChange={this.handleOptionChange}
                                >
                                    <FormControlLabel
                                        value="crop"
                                        control={<Radio color="primary" />}
                                        label={this.props.t<string>("Components.ImageSelectionDialog.CropText")}
                                    />

                                    <FormControlLabel
                                        value="resize"
                                        control={<Radio color="primary" />}
                                        label={this.props.t<string>("Components.ImageSelectionDialog.ResizeText")}
                                    />
                                </RadioGroup>
                            </FormGroup>
                        </Grid>
                    }

                    {
                        canBeCropped && option == "resize" &&
                        <Grid item>
                            <FormGroup row style={{ alignItems: "center" }}>
                                <FormLabel>{this.props.t("Components.ImageSelectionDialog.RotationText")}</FormLabel>
                                <RadioGroup
                                    row
                                    name="rotate"
                                    value={rotate.toString()}
                                    style={{ marginLeft: 8 }}
                                    onChange={this.handleRotateChange}

                                >
                                    <FormControlLabel
                                        value="0"
                                        control={<Radio color="primary" />}
                                        label="0"
                                    />
                                    <FormControlLabel
                                        value="90"
                                        control={<Radio color="primary" />}
                                        label="90"
                                    />
                                    <FormControlLabel
                                        value="180"
                                        control={<Radio color="primary" />}
                                        label="180"
                                    />
                                    <FormControlLabel
                                        value="270"
                                        control={<Radio color="primary" />}
                                        label="270"
                                    />
                                </RadioGroup>
                            </FormGroup>
                        </Grid>
                    }
                </Grid>

                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <div className={classNames(classes.imageBorder, classes.imageContainer)} >
                            {
                                option == "resize" &&
                                <div className={classes.imageBoxArea}>
                                    <img
                                        id="imgResize"
                                        alt="Original Image"
                                        src={image}
                                        onLoad={() => this.onLoadImageToRedim(document.getElementById("imgResize") as HTMLImageElement)}
                                    />
                                </div>

                            }

                            {
                                option == "crop" &&
                                <ReactCrop
                                    locked={false}
                                    src={image}
                                    crop={crop}
                                    className={classes.imageBoxArea}
                                    onImageLoaded={this.onCropImageLoaded}
                                    onComplete={this.onCropComplete}
                                    onChange={this.onCropChange}
                                />
                            }

                            <p>
                                {this.props.t("Components.ImageSelectionDialog.OriginalSize")}: {this.originalSize.width} x {this.originalSize.height}
                            </p>
                        </div>
                    </Grid>

                    <Grid item xs={6}>
                        <div className={classNames(classes.imageBorder, classes.imageContainer)} >

                            <div className={classes.imageBoxArea}>
                                <Grid container justifyContent="center" alignItems="center" className={classes.fullHeight} >
                                    <Grid item className={classes.fullHeight}>
                                        {
                                            previewImage &&
                                            <img
                                                id="previewImageSelection"
                                                alt="New Image Preview"
                                                src={previewImage.dataUrl}
                                                className={previewImage.width > previewImage.height ? classes.previewImageW : classes.previewImageH}
                                            />
                                        }
                                    </Grid>
                                </Grid>
                            </div>

                            <p>
                                {this.props.t("Components.ImageSelectionDialog.FinalSize")}: {this.props.width} x {this.props.height}
                            </p>
                        </div>
                    </Grid>
                </Grid>
            </>
        );
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface ILocalImageState {
    finalImageUrl: string;
    loading: boolean;
    src: string;
    fileProps: {
        size: number;
        name: string;
        type: string;
    };
}

interface ILocalImageProps {
    acceptedFiles?: string[];
    allowEdit: boolean;
    dimensions: ImageDimensions;
    initialFile?: File;
    onChange: (image: ImageSelectionResult) => void;
    onError: (message: string) => void;
}

type LocalImageProps = ILocalImageProps & ImageSelectionStyleTypes & WithTranslation & WithSnackbar;

class LocalImage extends React.PureComponent<LocalImageProps, ILocalImageState> {

    constructor(props: LocalImageProps) {
        super(props);

        this.state = {
            src: null,
            fileProps: null,
            finalImageUrl: null,
            loading: false,
        };
    }

    private loadFile(file: File) {

        this.setState({ src: null, fileProps: null, loading: true });

        convertBlobToBase64(file)
            .then((originalSource) => {

                this.setState({ src: originalSource, fileProps: file }, () => {
                    this.props.onChange({
                        source: { sourceDataOrUrl: originalSource, name: file.name, contentType: file.type },
                        editedImage: null
                    });
                });

            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    private onSelectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            this.loadFile(e.target.files[0]);
        }
    };

    private handlePaste = (images: File[]) => {
        if (images && images.length > 0) {
            this.loadFile(images[0]);
        }
    };

    private replaceExtension(filename: string, ext: string) {
        var i = filename.lastIndexOf('.');
        if (i > -1) return filename.substr(0, i - 1) + ext;
        return filename;
    }

    public componentDidMount() {
        if (this.props.initialFile) {
            this.loadFile(this.props.initialFile);
        }
        else {
            this.props.onChange(null);
        }
    }

    public render() {
        const { src, fileProps } = this.state;
        const { acceptedFiles, classes, dimensions, allowEdit } = this.props;

        return (
            <>
                <input
                    id="ImageSelectionFile"
                    type="file"
                    accept={acceptedFiles?.join(",")}
                    style={{ display: "none" }}
                    onChange={this.onSelectFile}
                />

                <Grid container direction="column" wrap="nowrap" className={classes.fullHeight}>
                    <Grid item className={classes.fullWidth}>
                        {
                            src != null &&
                            <MuiContainer margin="dense">
                                <Grid container justifyContent="space-between" alignItems="center">
                                    <Grid item>
                                        <Link
                                            href={null}
                                            style={{ cursor: "pointer" }}
                                            onClick={
                                                () => {
                                                    this.setState({ src: null, fileProps: null, finalImageUrl: null, loading: false });
                                                }
                                            }
                                        >
                                            <span>{this.props.t("Components.ImageSelectionDialog.SelectNewImageText")}</span>
                                        </Link>
                                    </Grid>
                                    <Grid item>
                                        <b>{fileProps.name}</b> &ndash; <span>{Formaters.fileSize(fileProps.size)}</span>
                                    </Grid>
                                </Grid>
                            </MuiContainer>
                        }
                    </Grid>

                    <Grid item className={classNames(classes.fullWidth, GlobalClassKeys.grow)}>
                        {
                            src == null
                                ? (
                                    <>
                                        <PasteContainer
                                            onPaste={files => this.handlePaste(files)}
                                            onError={err => console.error(err)}
                                        />
                                        <Dropzone
                                            accept={this.props.acceptedFiles}
                                            multiple={false}
                                            onDropRejected={
                                                () => this.props.snackbar.showMessage(this.props.t("Components.AttachSelection.FileNotAccept"), "error")
                                            }
                                            onDropAccepted={
                                                (e) => {
                                                    this.loadFile(e[0]);
                                                }
                                            }
                                        >
                                            {
                                                ({ getRootProps, getInputProps }) => {
                                                    return (
                                                        <div
                                                            {...getRootProps()}
                                                            className={classNames(this.props.classes.dropZone, classes.fullWidth, classes.fullHeight)}
                                                        >
                                                            <input {...getInputProps()} />

                                                            <Grid container justifyContent="center" className={classes.fullHeight}>
                                                                <Grid item style={{ alignSelf: "center", textAlign: "center" }}>
                                                                    <span>
                                                                        {this.props.t("Components.ImageSelectionDialog.DropHereText")}
                                                                        <br />
                                                                        {this.props.t("Components.ImageSelectionDialog.DropHereText2")}
                                                                    </span>
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                    );
                                                }
                                            }
                                        </Dropzone>
                                    </>
                                )
                                : src && !allowEdit
                                    ? (

                                        <div className={classNames(classes.imageBorder, classes.imageContainer, classes.imageCrop)} >
                                            <img src={src} alt="" className={classes.fullHeight} />
                                        </div>

                                    )
                                    : src && allowEdit
                                        ? (

                                            <EditImage
                                                {...dimensions}
                                                i18n={this.props.i18n}
                                                t={this.props.t}
                                                tReady={this.props.tReady}
                                                src={src}
                                                classes={this.props.classes}
                                                onError={
                                                    (message) => {
                                                        this.setState(
                                                            { src: null, fileProps: null, finalImageUrl: null, loading: false },
                                                            () => this.props.onError(message)
                                                        );
                                                    }
                                                }
                                                onChange={
                                                    (data) => {
                                                        this.props.onChange({
                                                            source: { sourceDataOrUrl: src, name: fileProps.name, contentType: fileProps.type },
                                                            editedImage: { sourceDataOrUrl: data.dataUrl, name: this.replaceExtension(fileProps.name, ".png"), contentType: "image/png" }
                                                        });
                                                    }
                                                }
                                            />
                                        )
                                        : null
                        }
                    </Grid>
                </Grid>
            </>
        );
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const CloudTakeRecords = 24;

interface ICloudImageState {
    loading: boolean;
    searchTerm: string;
    lastSearchTerm: string;
    offset: number;
    selectedItem: AzureSearchImageItem;
    data: AzureSearchImageResult;
}

class CloudImage extends React.PureComponent<LocalImageProps, ICloudImageState> {

    constructor(props: LocalImageProps) {
        super(props);

        this.state = {
            loading: false,
            searchTerm: "",
            lastSearchTerm: "",
            offset: 0,
            data: null,
            selectedItem: null
        };
    }

    private load(offset: number) {

        var searchTerm = this.state.searchTerm;

        if (this.state.loading || searchTerm.length == 0)
            return;

        this.setState({ loading: true });

        api.azureSearchImage({ searchTerm: searchTerm }, offset, CloudTakeRecords)
            .then((result) => {
                this.setState({
                    loading: false,
                    data: result,
                    offset: offset,
                    lastSearchTerm: searchTerm
                });
            });
    }

    private selectImage(item: AzureSearchImageItem) {

        this.setState({ selectedItem: item }, () => {

            if (!this.props.allowEdit) {
                this.props.onChange({
                    source: {
                        sourceDataOrUrl: item.contentUrl,
                        name: `${item.name}.${item.encodingFormat}`,
                        contentType: `image/${item.encodingFormat}`
                    },
                    editedImage: null
                });
            }

        });
    }

    private getImageFileSize(size: string) {
        var s = parseInt(size.match(/-?\d+/gi).join(''), 10);
        return Formaters.fileSize(s);
    }

    private handleCancelSelection = () => {
        this.setState({ selectedItem: null }, () => {
            this.props.onChange(null);
        });
    };

    private onLoadImageError = () => {
        this.props.onError(this.props.t("Components.ImageSelectionDialog.CloudImageLoadError"));
        this.handleCancelSelection();
    };

    public componentDidMount() {
        this.props.onChange(null);
    }

    public render() {
        const { loading, data, selectedItem } = this.state;
        const { classes, dimensions, allowEdit } = this.props;
        const contentUrl = selectedItem ? `/api/v1.0/AzureSearch/ImageProxy?url=${selectedItem.contentUrl}&contentType=image/${selectedItem.encodingFormat}` : null;
        const label = this.props.t("Common.Input.Label.SearchFor");
        const placeholder = this.props.t("Common.Input.Placeholder.SearchImage");
        const chooseText = this.props.t("Components.ImageSelectionDialog.ChooseAnotherImageText");

        return (

            <Grid container direction="column" wrap="nowrap" className={classes.fullHeight}>

                <Grid item className={classes.fullWidth}>
                    {
                        contentUrl
                            ? (
                                <MuiContainer margin="dense">
                                    <Link onClick={this.handleCancelSelection} href={null} style={{ cursor: "pointer" }}><IconBack /> {chooseText}</Link>
                                </MuiContainer>
                            )
                            : <TextField
                                label={label}
                                placeholder={placeholder}
                                fullWidth={true}
                                margin={"dense"}
                                disabled={loading}
                                autoFocus={true}
                                value={this.state.searchTerm}
                                onBlur={
                                    () => {
                                        if (this.state.searchTerm != this.state.lastSearchTerm) this.load(0);
                                    }}
                                onKeyUp={
                                    (e) => {
                                        if (e.keyCode == 13 && this.state.searchTerm != this.state.lastSearchTerm) this.load(0);
                                    }
                                }
                                onChange={
                                    (event: React.ChangeEvent<HTMLInputElement>) => {
                                        this.setState({ searchTerm: event.target.value });
                                    }}
                            />
                    }
                </Grid>

                <Grid item className={classNames(GlobalClassKeys.grow, classes.fullWidth)}>
                    {
                        loading
                            ? <SpinnerIndicator />
                            : data && data.count == 0
                                ? <Alert severity="warning">{this.props.t("Components.ImageSelectionDialog.CloudImageNotFound")}</Alert>
                                : data && !contentUrl
                                    ? (
                                        <div className={classes.gridRoot}>
                                            <MuiContainer margin="dense">
                                                <ImageList rowHeight={150} className={classes.ImageList} cols={3} >
                                                    {
                                                        data.items.map((v) => (
                                                            <ImageListItem
                                                                key={v.thumbnailUrl}
                                                                cols={1}
                                                                onClick={() => this.selectImage(v)}
                                                            >
                                                                <img src={v.thumbnailUrl} alt={v.description || v.name} />
                                                                <ImageListItemBar
                                                                    title={v.name}
                                                                    subtitle={<span>{`${v.width}x${v.height}`} &ndash; {v.encodingFormat} &ndash; {this.getImageFileSize(v.contentSize)}</span>}
                                                                />
                                                            </ImageListItem>
                                                        ))
                                                    }
                                                </ImageList>
                                            </MuiContainer>
                                            <MuiPagination
                                                limit={CloudTakeRecords}
                                                offset={this.state.offset}
                                                total={data.total}
                                                onClick={(e, offset) => this.load(offset)}
                                            />
                                        </div>
                                    )
                                    : contentUrl && !allowEdit
                                        ? (
                                            <div className={classNames(classes.imageBorder, classes.imageContainer)} >
                                                <div style={{ width: dimensions.width, height: dimensions.height, margin: "0 auto" }}>
                                                    <img
                                                        src={contentUrl}
                                                        alt=""
                                                        onError={this.onLoadImageError}
                                                        className={classes.previewImageH}
                                                    />
                                                </div>
                                            </div>
                                        )
                                        : contentUrl && allowEdit
                                            ? (
                                                <EditImage
                                                    {...dimensions}
                                                    i18n={this.props.i18n}
                                                    t={this.props.t}
                                                    tReady={this.props.tReady}
                                                    src={contentUrl}
                                                    classes={this.props.classes}
                                                    onError={
                                                        (message) => {
                                                            this.setState(
                                                                { selectedItem: null },
                                                                () => this.props.onError(message)
                                                            );
                                                        }
                                                    }
                                                    onChange={
                                                        (dataUrl) => {
                                                            this.props.onChange({
                                                                source: {
                                                                    sourceDataOrUrl: selectedItem.contentUrl,
                                                                    name: `${selectedItem.name}.${selectedItem.encodingFormat}`,
                                                                    contentType: `image/${selectedItem.encodingFormat}`
                                                                },
                                                                editedImage: {
                                                                    sourceDataOrUrl: dataUrl.dataUrl,
                                                                    name: `${selectedItem.name}_cropped.png`,
                                                                    contentType: "image/png"
                                                                }
                                                            });
                                                        }}

                                                />
                                            )
                                            : null
                    }
                </Grid>
            </Grid>
        );
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    fileResult: ImageSelectionResult;
    src: string;
    tabSelected: string;
    editMode: boolean;
}

interface IProps {
    allowEdit: boolean;
    dimensions: ImageDimensions;
    initialSource: "library" | "local";
    acceptedFiles?: string[];
    initialFile?: File;
    onClose: (result: ImageSelectionResult) => void;
}

type Props = IProps & WithStyles<typeof ImageSelectionStyles> & WithSnackbar & WithTranslation;

class ImageSelectionDialog extends React.PureComponent<Props, IState> {

    private initialFile: File;

    constructor(props: Props) {
        super(props);

        this.state = {
            editMode: false,
            src: null,
            fileResult: null,
            tabSelected: props.initialFile != null ? "local" : props.initialSource
        };

        this.initialFile = props.initialFile;
    }

    private handleTabSelection = (event: React.ChangeEvent<{}>, value: any) => {
        this.setState({ tabSelected: value });
    };

    private handleFileChanged = (result: ImageSelectionResult) => {
        this.setState({ fileResult: result });
    };

    private handleError = (message: string) => {
        this.props.snackbar.showMessage(message, "error");
    };

    public componentDidMount() {
        this.initialFile = null;
    }

    public render() {
        const { fileResult, tabSelected } = this.state;
        const { acceptedFiles, classes, dimensions, allowEdit, onClose } = this.props;
        const title = this.props.t("Components.ImageSelectionDialog.DialogTitle");

        return (

            <Dialog
                open
                fullWidth
                maxWidth="md"
                role="dialog"
            >
                <DialogTitle style={{ paddingTop: 8, paddingBottom: 8 }} >
                    <span>{title}</span>
                </DialogTitle>

                <DialogContent>
                    <Grid container direction="column" wrap="nowrap" style={{ height: 480 }}>
                        <Grid item>
                            <RenderMenuBar {...this.props} category={tabSelected} onChange={this.handleTabSelection} />
                        </Grid>

                        <Grid item className={GlobalClassKeys.grow}>
                            {
                                tabSelected == "library" &&
                                <CloudImage
                                    i18n={this.props.i18n}
                                    t={this.props.t}
                                    tReady={this.props.tReady}
                                    snackbar={this.props.snackbar}
                                    acceptedFiles={acceptedFiles}
                                    allowEdit={allowEdit}
                                    dimensions={dimensions}
                                    classes={classes}
                                    onChange={this.handleFileChanged}
                                    onError={this.handleError}
                                />
                            }

                            {
                                tabSelected == "local" &&
                                <LocalImage
                                    i18n={this.props.i18n}
                                    t={this.props.t}
                                    tReady={this.props.tReady}
                                    snackbar={this.props.snackbar}
                                    acceptedFiles={acceptedFiles}
                                    allowEdit={allowEdit}
                                    dimensions={dimensions}
                                    initialFile={this.initialFile}
                                    classes={classes}
                                    onChange={this.handleFileChanged}
                                    onError={this.handleError}
                                />
                            }
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>

                    <ButtonCancel
                        onClick={() => {
                            if (this.state.fileResult && this.state.fileResult.source && this.state.fileResult.source.sourceDataOrUrl.indexOf("blob") == 0) {
                                URL.revokeObjectURL(this.state.fileResult.source.sourceDataOrUrl);
                            }

                            onClose(null);
                        }}
                    />

                    {
                        fileResult &&
                        <ButtonConfirmAndClose
                            onClick={() => { onClose(this.state.fileResult); }}
                        />
                    }

                </DialogActions>

            </Dialog >
        );
    }
}

export default withSnackbar(withTranslation()(withStyles(ImageSelectionStyles)(ImageSelectionDialog)));